// @mui material components
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
} from "@mui/material";

import MDBox from "theme/components/MDBox";
import MDButton from "theme/components/MDButton";

import { useState } from "react";
import parse from "html-react-parser";

function CompanyNotification(notificationObject) {
  const [showCompanyNotification, setShowCompanyNotification] = useState(true);
  const { title, description } = notificationObject;

  return (
    <Dialog open={showCompanyNotification}>
      <DialogTitle>
        <MDBox>{parse(title)}</MDBox>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <MDBox>{parse(description)}</MDBox>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MDButton
          onClick={() => {
            setShowCompanyNotification(false);
          }}
          color="dark"
          variant="outlined"
        >
          Close
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

export default CompanyNotification;
